var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowBanner)?_c('Alert',{attrs:{"variant":"warning","message":_vm.announcementText,"icon":_vm.Megaphone,"icon-size":32,"custom-class":"mb-6"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }